import { useEffect, useMemo, useState } from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Checkbox } from "antd";

import {
    NotificationRecipientKind,
    UserGroupView,
    UserOverview,
} from "api/generated/model";
import { BaseFormDisplay } from "components/form/legacyFields/formDisplay";

import { NotifyOnControlCompletionTable } from "./NotifyOnControlCompletionTable";
import * as theme from "./theme.css";

interface NotifyOnControlCompletionSectionProps {
    notificationRecipients: NotificationRecipientKind[];
    onNotificationRecipientChanged: (
        recipientsKind: NotificationRecipientKind
    ) => void;
    onNotificationRecipientRemoved: (
        recipientsKind: NotificationRecipientKind
    ) => void;
    onUserAdded: (user: UserOverview) => void;
    onUserGroupAdded: (userGroup: UserGroupView) => void;
}

export const NOTIFY_ON_CONTROL_COMPLETION =
    "notify-on-control-completion-section";

export function NotifyOnControlCompletionSection({
    notificationRecipients,
    onNotificationRecipientChanged,
    onNotificationRecipientRemoved,
    onUserAdded,
    onUserGroupAdded,
}: NotifyOnControlCompletionSectionProps) {
    const initialNotificationRecipients = useMemo(
        () => notificationRecipients.length > 0,
        [notificationRecipients]
    );

    const [showTable, setShowTable] = useState(initialNotificationRecipients);

    useEffect(() => {
        //when toggling off the checkbox, remove all notification recipients
        if (!showTable && notificationRecipients.length > 0) {
            notificationRecipients.forEach((recipient) =>
                onNotificationRecipientRemoved(recipient)
            );
        }
    }, [showTable, notificationRecipients, onNotificationRecipientRemoved]);

    return (
        <BaseFormDisplay label={t("Control_Assignment_Notify")}>
            <div
                className={theme.verticalSpacer}
                id={NOTIFY_ON_CONTROL_COMPLETION}
            >
                <Checkbox
                    onChange={(e) => setShowTable(e.target.checked)}
                    checked={showTable}
                >
                    {t("Control_Notify_EnableLabel")}
                </Checkbox>
            </div>
            {
                <NotifyOnControlCompletionTable
                    showTable={showTable}
                    value={notificationRecipients}
                    onNotificationRecipientChanged={
                        onNotificationRecipientChanged
                    }
                    onNotificationRecipientRemoved={
                        onNotificationRecipientRemoved
                    }
                    onUserAdded={onUserAdded}
                    onUserGroupAdded={onUserGroupAdded}
                />
            }
        </BaseFormDisplay>
    );
}
